import { LocalDBService } from './../../service/local-db.service';
import { AwsUtil } from './../../authentication/aws.service';
import { DisplayCurveComponent, getAllCurvesTreeNodes } from './../../market-data/curve/display-curve.component';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { ALMDashboardMetricBarConfigurator, ALMDashboardMetricData } from './../../alm/alm-dashboard';
import { DashboardViewSelection } from '../../dashboard/dashboard-view-selection';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { CurrencyDisplayUtil } from '../../common/currency-display-util';
import { Subscription } from 'rxjs';
import { AppConfig } from '../../app.config';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Component, OnInit, Output, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { ApplicationConfiguration, UserProfile } from '@liquitics/transaction';
import { FinancialDate } from '@liquitics/transaction';
import { hyphenatedMonthDay } from '@liquitics/transaction';

import * as moment from 'moment';

export enum RiskViewMode {
    METRIC,
    CHART
}

@Component({
    selector: 'app-home-sidebar-alm',
    templateUrl: './sidebar-alm.component.html',
    styleUrls: ['./../home.sidebar.component.scss', './sidebar-alm.component.scss']
})
export class SidebarALMComponent implements OnInit, OnDestroy, AfterViewInit {
    currencies: string[] = [];
    selectedViewSelection: DashboardViewSelection<ALMDashboardMetricData>;
    selectedCurrency: string;

    batches: { [key: string]: string }[];
    selectedBatch: { [key: string]: string };
    @Input()
    profileType: string;
    subscription: Subscription;
    viewMode: string;

    constructor(
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig,
        private snapshotService: SnapshotService,
        private awsUtil: AwsUtil,
        private localDBService: LocalDBService,
        private dialog: MatDialog) {
    }

    ngOnInit() {
        this.viewMode = this.profileType === 'ALM_MANAGER' ? 'DASHBOARD' : 'LADDER';
        this.reinitializeData();
        this.subscription = this.dashboardEventService.currencySelectionSubject.subscribe({
            next: (currency: string) => {
                this.selectedCurrency = currency;
                this.selectedViewSelection.currency = currency;
                this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
            }
        });
        this.subscription.add(this.dashboardEventService.applicationConfigurationSubject
            .subscribe({
                next: (applicationConfiguration: ApplicationConfiguration) => {
                    this.reinitializeData();
                }
            })
        );
        this.dashboardEventService.profileSubject.subscribe({
            next: (userProfile: UserProfile) => {
                this.viewMode = userProfile.getProfileType() === 'ALM_MANAGER' ? 'DASHBOARD' : 'LADDER';
                this.dashboardEventService.viewModeSelectionSubject.next(this.viewMode);
            }
        });
        setTimeout(() => {
            this.dashboardEventService.viewModeSelectionSubject.next(this.viewMode);
        }, 50)
    }

    reinitializeData() {
        this.currencies = [...this.appConfig.activeUserProfile.getCurrencies()];
        this.currencies.push('BASE');
        this.selectedCurrency = this.currencies[0];

        this.batches = this.snapshotService.applicationConfiguration.batchIdentifiers
            .filter((modeBatchIdentifier: string) => {
                return modeBatchIdentifier.startsWith('ALM');
            })
            .map((modeBatchIdentifier: string) => {
                return modeBatchIdentifier.split('=')[1];
            })
            .map((batchIdentifier: string) => {
                return batchIdentifier.split('_');
            })
            .filter((splits: string[]) => {
                return splits.length >= 2;
            })
            .map((splits: string[]) => {
                const date = hyphenatedMonthDay(moment.utc(splits[0]));
                return {
                    batchIdentifier: splits.join('_'),
                    organizationName: splits[1],
                    identifier: splits.splice(2).join('_'),
                    date: date,
                    rawDate: splits[0],
                };
            })
            .sort((b1, b2) => {
                if (b1.organizationName === b2.organizationName) {
                    return (b1.rawDate < b2.rawDate) ? -1 : (b1.rawDate === b2.rawDate) ? 0 : 1;
                } else {
                    return (b1.organizationName > b2.organizationName) ? -1 : 1;
                }
            });
        if (this.batches.length > 0) {
            this.selectedBatch = this.batches[0];
            this.selectedViewSelection = {
                currency: this.selectedCurrency,
                type: 'ALM',
                batchIdentifier: this.selectedBatch.batchIdentifier,
                metricBarConfigurator: new ALMDashboardMetricBarConfigurator(),
            } as DashboardViewSelection<ALMDashboardMetricData>;
            this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
            this.dashboardEventService.ladderViewModeSubject.next('LADDER');
        }
        // Disable loading for now and refactor later as this is simply too much traffic to load each time given the number of curves
        // this.loadAllCurveDataInBackground();
    }

    loadAllCurveDataInBackground() {
        if (!this.localDBService.getRegisteredPromise('AllCurveTreeNodes')) {
            const currencies = this.appConfig.activeUserProfile.getCurrencies();
            const completedDay = FinancialDate.fromString(this.appConfig.getTodayString()).addDays(-1).getDateString();
            setTimeout(() => {
                // Wait 30 secodns before we start making massive caching calls. We want the primary data to load first
                this.localDBService.registerPromise('AllCurveTreeNodes',
                    getAllCurvesTreeNodes(currencies, completedDay, this.awsUtil, this.snapshotService.applicationConfiguration));
            }, 30_000);
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
    }

    initializeSideBar() {
    }

    onCurrencyChange(event: MatButtonToggleChange) {
        this.selectedViewSelection.currency = event.value;
        this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
    }

    onBatchChange(event: MatButtonToggleChange) {
        this.selectedViewSelection.batchIdentifier = event.value.batchIdentifier;
        this.dashboardEventService.viewSelectionSubject.next(this.selectedViewSelection);
    }
    onViewModeChange(event: MatButtonToggleChange) {
        this.viewMode = event.value;
        this.dashboardEventService.viewModeSelectionSubject.next(this.viewMode);
    }
    openDisplayCurveDialog(event: MatButtonToggleChange) {
        this.loadAllCurveDataInBackground();
        const dialogRef = this.dialog.open(DisplayCurveComponent, {
            width: '80%',
            height: '80%',
            data: {
            }
        });
    }

    flagIconClass(block) {
        const flagCode = CurrencyDisplayUtil.flagCodeForCurrency(block);
        if (!flagCode) {
            return '';
        }
        return 'flag-icon flag-icon-' + flagCode;
    }
}
